<script setup lang="ts">
import type { PortableTextMarkComponentProps } from '@portabletext/vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<
  PortableTextMarkComponentProps<{
    // Keys come in under props.value
    _key: string;
    _type: string;
    href: string;
    ctaStyle?: boolean;
  }>
>();
</script>

<template>
  <NuxtLink v-if="props.value?.href" :to="props.value.href" target="_blank">
    <UiButton v-if="props.value?.ctaStyle">
      <slot />
    </UiButton>
      <slot v-else/>
  </NuxtLink>
  <span v-else>
      <slot />
  </span>
</template>
